import ReactDOM from 'react-dom/client'
import apiRoutes from 'routes/admin_api_routes.json'

import { makeActionCreator } from '../../util/make_action_creator'
import { handleApiError } from '../../util/parse_server_error'
import { buildPagedURL, setFetched } from '../api/actions'
import { setTimelinesPaging } from '../paging/actions'

export const TIMELINES_FETCH_SIZE = 20

export const SET_REPLY_TIMELINE_ID = 'SET_REPLY_TIMELINE_ID'
export const setReplyTimelineId = makeActionCreator(
  SET_REPLY_TIMELINE_ID,
  'topicId',
  'id',
)

export function fetchTimelines(topicId, afterId = null) {
  return function (axios, dispatch) {
    if (!topicId)
      return Promise.reject(
        new Error('Cannot fetch timelines for undefined topicId'),
      )

    const path = apiRoutes.admin_api_v1_topic_timelines.path
    const url = path.replace(':topic_id', topicId)
    const pageSize = afterId ? null : TIMELINES_FETCH_SIZE

    const urlPaged = buildPagedURL(url, {
      after: afterId,
      before: null,
      limit: pageSize,
      filter: null,
    })

    return axios()
      .get(urlPaged)
      .then(
        (result) => {
          const matches = result.data.matches
          const after = matches[0]
          const before = !afterId && matches[matches.length - 1]
          dispatch(
            setTimelinesPaging(topicId, {
              after,
              ...(!afterId && {
                before,
                hasMore: matches.length === TIMELINES_FETCH_SIZE,
                cachedBefore: before,
              }),
            }),
          )
          dispatch(setFetched('timelines', result.data.records))
          const hasMore = !afterId && matches.length === pageSize
          if (hasMore) {
            return dispatch(axios(fetchMoreTimelines(topicId, before)))
          } else {
            return Promise.resolve()
          }
        },
        (result) => {
          handleApiError({
            dispatch,
            result,
            path,
          })
          return Promise.reject(result)
        },
      )
  }
}

export function fetchMoreTimelines(topicId, beforeId) {
  return function (axios, dispatch) {
    if (!topicId) return Promise.reject()

    const path = apiRoutes.admin_api_v1_topic_timelines.path
    const url = path.replace(':topic_id', topicId)
    const urlPaged = buildPagedURL(url, {
      after: null,
      before: beforeId,
      limit: TIMELINES_FETCH_SIZE,
      filter: null,
    })

    return axios()
      .get(urlPaged)
      .then(
        (result) => {
          const matches = result.data.matches
          const before = matches[matches.length - 1]
          dispatch(
            setTimelinesPaging(topicId, {
              before,
              hasMore: matches.length === TIMELINES_FETCH_SIZE,
            }),
          )
          dispatch(setFetched('timelines', result.data.records))

          return Promise.resolve(result)
        },
        (result) => {
          handleApiError({
            dispatch,
            result,
            path,
          })
          return Promise.reject(result)
        },
      )
  }
}

export function toggleEmojiReaction(topicId, timelineId, emojiAsColons) {
  return function (axios, dispatch) {
    const path = apiRoutes.admin_api_v1_topic_timeline.path
    const url = path.replace(':topic_id', topicId).replace(':id', timelineId)
    const timelineData = {
      emoji_reaction: {
        emoji_colon_format: emojiAsColons,
      },
    }
    return axios()
      .put(url, timelineData)
      .then(
        (result) => {
          dispatch(setFetched('timelines', result.data.records))
          return Promise.resolve(result)
        },
        (result) => {
          handleApiError({
            dispatch,
            result,
            path,
          })
          return Promise.reject(result)
        },
      )
  }
}
